import React from 'react';

class VBStepper extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    const { currentStep } = this.props;
    return (
      <div className='d-flex justify-content-center'>
        <div className='col-lg-6 col-12'>
          <div className='d-flex align-items-center'>
          
            <div className=''>
              <div className={`d-flex justify-content-center rounded-circle border border-2 p-2 fw-bold ${currentStep === 1 ? 'success-500 border-success-500' : 'success-500 border-success-500'}`} style={{ width: '40px', height: '40px' }}>
                {currentStep === 1 ? '1' : <img className="icon-sm success-500-filter" style={{ width: "18px", height: "18px" }} src={Window.static_path + "img/icons/tick3.svg"} alt="" />}
              </div>
            </div>
            <hr className='w-50 border border-success-500 opacity-100' />
            <hr className={`w-50 opacity-100 ${currentStep === 2 || currentStep > 2 ? 'border border-success-500' : 'neutral-cloud-700 border-neutral-cloud-700'}`} />


            <div className=''>
              <div className={`d-flex justify-content-center rounded-circle border p-2 ${currentStep === 2 ? 'success-500 border-success-500 border-2 fw-bold' : currentStep > 2 ? 'success-500 border-success-500 border-2 fw-bold' : 'neutral-cloud-700 border-neutral-cloud-700'}`} style={{ width: '40px', height: '40px' }}>
                {currentStep === 2 || currentStep === 1 ? '2' : currentStep > 2 && <img className="icon-sm success-500-filter" style={{ width: "18px", height: "18px" }} src={Window.static_path + "img/icons/tick3.svg"} alt="" />}
              </div>
            </div>
            <hr className={`w-50 opacity-100 ${currentStep === 2 || currentStep > 2 ? 'border border-success-500' : 'neutral-cloud-700 border-neutral-cloud-700'} `} />
            <hr className={`w-50 opacity-100 ${currentStep === 3 || currentStep > 3 ? 'border border-success-500' : 'neutral-cloud-700 border-neutral-cloud-700'} `} />

            <div className=''>
              <div className={`d-flex justify-content-center rounded-circle border p-2 ${currentStep === 3 ? 'success-500 border-success-500 border-2 fw-bold' : currentStep > 3 ? 'success-500 border-success-500 border-2 fw-bold' : 'neutral-cloud-700 border-neutral-cloud-700'}`} style={{ width: '40px', height: '40px' }}>3</div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default VBStepper;